import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core'
import { OrderClass, DataPageOfOrder, Order, UiPreferences } from '../../../../../api/models'
import { FormControl, UntypedFormBuilder } from '@angular/forms'
import { AppSettingService, ColumnChooserService, OrderClassService, OrderService } from '../../../../../api/services'
import { MessageService, ConfirmationService, SortEvent } from 'primeng/api'
import { Router, ActivatedRoute } from '@angular/router'
import { Customsort } from '../../../../directives/customsort'
import { environment } from '../../../../../../environments/environment'
import { DatePipe } from '@angular/common'
import { CareFinitySession } from '../../../../services/CareFinitySession'
import { BehaviorSubject, Subject, combineLatest, filter, map, of, startWith, switchMap, takeUntil, tap } from 'rxjs'
import { Table } from 'primeng/table';
@Component({
    selector: 'app-order-list',
    templateUrl: './order-list.component.html',
    styleUrls: ['./order-list.component.css'],
})
export class OrderListComponent implements OnInit, OnDestroy {
    Item = 'Orders'
    orderclassList: Array<OrderClass> = [];
    orders: DataPageOfOrder
    selectedPatient: Order
    showRecords: boolean = false
    _selectedColumns: any[]

    private cols: any[]
    orderclass = new FormControl([])
    rows: number
    pageNumber: number = 1
    sortBy: string = ''
    pageSize: number = 0;

    orders$ = new BehaviorSubject([]);
    ordersObservable;
    private destroy = new Subject<void>();
    isSearchByVoice = true;
    preferences: UiPreferences = {};

    showPatientOrdersPrint: boolean = true;
    patientFullName;
    setPrintFlag: boolean = false;
    showPatientDemographicPrint: boolean = false;

    @ViewChild('dt') table1!: Table;
    @ViewChild('dt1') table2!: Table;

    constructor(
        private fb: UntypedFormBuilder,
        private orderclassservice: OrderClassService,
        private orderservice: OrderService,
        private messageService: MessageService,
        private confirmation: ConfirmationService,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private customsort: Customsort,
        private datePipe: DatePipe,
        private columnchooserservice: ColumnChooserService,
        private appSetting: AppSettingService

    ) {
    }
    ngOnDestroy(): void {

        this.destroy.next();
    }

    ngOnInit() {
        this.patientFullName = sessionStorage.getItem('ptName');

        this.pageSize = CareFinitySession?.applicationSettings?.apiDataPageSize;
        this.cols = [
            { field: 'enDate', header: 'Visit Date' },
            { field: 'class', header: 'Order Type' },
            { field: 'description', header: 'Description' },
            { field: 'status', header: 'Status' },
            { field: 'orderedBy', header: 'Entered By' },
        ]


        this.appSetting
            .appSettingGetPracticeSettings$Response()
            .subscribe((res) => {
                this.showPatientDemographicPrint = res.body.enablePatientDemographicPrint;
                if (CareFinitySession?.user.roles.patientRecordsPrint == true && this.showPatientDemographicPrint == true) {
                    this.setPrintFlag = true;
                }
                else {
                    this.setPrintFlag = false;
                }
            })

        this.loadOrderClassList()





        const storedPreferences = localStorage.getItem('uiPreferences');
        if (storedPreferences) {
            this.preferences = JSON.parse(storedPreferences);

            this.Item = this.preferences?.orders || 'Orders';
        }


    }


    containsAny(arr1, arr2) {
        return arr1.some(item => arr2.includes(item));
    }
    @Input() get selectedColumns(): any[] {
        // console.log(this._selectedColumns);
        return this._selectedColumns
    }

    searchOrders(event) {

        console.log(event);
    }

    set selectedColumns(val: any[]) {
        let selectedValues = [...val]

        if (selectedValues.length == 0) {
            selectedValues = this._selectedColumns = [this.cols[0]]
        } else {
            //restore original order

            this._selectedColumns = val
        }

        let filteredData = Array.prototype.map
            .call(selectedValues, (s) => s.field)
            .toString()
        let filteredValue = Array.prototype.map
            .call(selectedValues, (s) => s.header)
            .toString()

        this.columnchooserservice
            .columnChooserColumnchooser({
                columnNames: filteredData,
                columnValue: filteredValue,
                type: 'Orders',
            })
            .subscribe((result) => { })
    }

    /**
     * This method fetch Order List.And also binds dropdown dynamic columns  list.
     * paramOuter:: []
     * paramInner:: [[pageNumber,sortbydirection],patientId,practiceId]
     * returns ::   [Array<OrderClass>]
     */

    loadOrderClassList(): void {
        this.orderclassservice
            .orderClassGetorderclass({
                patientId: sessionStorage.getItem('ptId'),
                emrpracticeId: localStorage.getItem('EmrPracticeId'),
            })
            .subscribe(
                (result) => {
                    this.orderclassList = result.filter(i => i.orderClassID !== "ALL").map(i => ({ ...i, "orderClassID": i.orderClassID.toLowerCase() }))
                    this.orderclass.setValue(this.orderclassList.map(i => i.orderClassID));
                    this.ordersObservable = combineLatest(this.orderclass.valueChanges.pipe(startWith(this.orderclass.value)), this.orders$).pipe(switchMap(([orderTypes, data]) => {
                        return of(
                            data.filter(o => { console.log(o); return orderTypes.indexOf(o.class.toLowerCase()) !== -1 })
                        )
                    }), takeUntil(this.destroy))
                    this.loadOrdersList(this.pageNumber, this.sortBy, 'All')
                }
            )
    }


    loadOrdersList(
        pageNumber: number,
        sortbydirection: string,
        orderclassid: string,
    ) {
        //debugger
        this.orderservice
            .orderList({
                patientId: sessionStorage.getItem('ptId'),
                emrpracticeId: localStorage.getItem('EmrPracticeId'),
                pageNumber: pageNumber,
                sortbydirection: sortbydirection,
                orderClass: orderclassid,
            })
            .subscribe(
                (respOrders) => {
                    //  console.log(respOrders);
                    this.orders = respOrders;
                    this.rows = this.orders.pageSize;

                    respOrders.data = respOrders.data.map((i) => ({
                        ...i,
                        ...i.otherColumns,
                    }))
                    this.orders$.next(respOrders.data)
                    if (this.orders.data.length > 0) {
                        this.showRecords = true
                    } else {
                        this.showRecords = false
                    }

                    let addedFields = new Set(this.cols.map((col) => col.field))
                    for (var key in this.orders.data[0].otherColumns) {
                        if (this.orders.data[0].otherColumns.hasOwnProperty(key)) {
                            // Check if key is already in addedFields set
                            if (!addedFields.has(key)) {
                                // Add to addedFields set
                                addedFields.add(key)

                                // Push to this.cols
                                this.cols.push({ field: key, header: key })
                            }
                        }
                    }

                    if (respOrders.data[0].savedColumns != null && respOrders.data[0].savedColumns.length > 0) {
                        var Savednames = respOrders.data[0].savedColumns.split(',')
                        this._selectedColumns = this.cols.filter((col) =>
                            Savednames.includes(col.field),
                        )
                    } else {
                        this._selectedColumns = this.cols
                    }
                },
                (err) => {
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: err?.error,
                        life: 3000,
                    })
                },
            )
    }

   

    searchonId(): void {

    }

    customSort(event: SortEvent, num: number) {
        this.orders.data = this.customsort.generalcustomSort(
            event,
            this.orders.data,
        )

        this.orders$.next(this.orders.data);
    }

    formatdatetime(item, type) {
        //debugger
        if (item != null && type.indexOf('Date') > -1) {
            return this.datePipe.transform(item, environment.dateformat)
        }
        return item
    }



    onFocus() {

        setTimeout(() => {
            // Get the dropdown panel using getElementsByClassName
            const dropdownPanels = document.getElementsByClassName('p-dropdown-panel p-component ng-star-inserted') as HTMLCollectionOf<HTMLElement>;

            // Check if any panel is found
            if (dropdownPanels.length > 0) {
                const dropdownPanel = dropdownPanels[0]; // Access the first element
                /*dropdownPanel.style.overflowY = 'scroll';*/

                dropdownPanel.style.height = '100% !important';
                dropdownPanel.style.maxHeight = '100%';


                const innerDiv = document.getElementsByClassName('p-dropdown-items-wrapper') as HTMLCollectionOf<HTMLElement>;

                if (innerDiv.length > 0) {

                    const innerDiv1 = innerDiv[0]; // Access the first element

                    let x = 600 + (this.orderclassList.length * 5);
                    let p = x + 'px';

                    // alert(p);
                    innerDiv1.style.maxHeight = p; //'600px'; // Set your desired max-height value
                    innerDiv1.style.overflowY = 'scroll';

                    //innerDiv1.style.removeProperty('max-height'); // or use dropdownPanel.style.maxHeight = ''; to clear it
                }


            }
        });
    }



    // clears the searchText field directly

    clearSearchText(searchText: HTMLInputElement) {
        searchText.value = '';
    }


    applyGlobalFilter(value: string) {
        this.table1.filterGlobal(value, 'contains');
        this.table2.filterGlobal(value, 'contains');
    }
    resetTables() {

        this.table1.reset();
        this.table2.reset();
    }
    printOrders() {




        var PrintOrders = document.getElementById('PrintOrders_List') as HTMLElement
        const printWindow = window.open('', '_blank')
        if (printWindow) {
            const divContent = PrintOrders.innerHTML
            printWindow.document.open()
            printWindow.document.write(
                '<html><head><title>Print::Orders List</title>',
            )
            // Adding CSS styling for alternate rows
            printWindow.document.write('<style type="text/css">')
            printWindow.document.write('#Orders_print_table_tbody tbody tr:nth-child(odd) {')
            printWindow.document.write('background-color: #f2f2f2;')
            printWindow.document.write('}')
            printWindow.document.write('#Orders_print_table_tbody tbody tr:nth-child(even) {')
            printWindow.document.write('background-color: #e6e6e6;')
            printWindow.document.write('}')
            printWindow.document.write('</style>')
            printWindow.document.write('</head><body>')
            printWindow.document.write(divContent)
            printWindow.document.write('</body><html>')
            printWindow.document.close()
            printWindow.focus()
            printWindow.print()
            printWindow.close()
        } else {
            console.error('Failed to open print window.')
        }

    }
}
